import { Platform } from "@src/mobile/utils/platform";

export interface HideSplashScreenOptions {
  fadeOutDuration?: number;
}

/**
 * Dismisses the native splash screen. No-op on web.
 *
 * Pair with the JS-level `MobileSplashOverlay` so the user transitions
 * cleanly from the native splash to the web splash to the app shell.
 */
export async function hideSplashScreen(options?: HideSplashScreenOptions): Promise<void> {
  if (!Platform.isMobile) {
    return;
  }

  const { SplashScreen } = await import("@capacitor/splash-screen");
  await SplashScreen.hide({ fadeOutDuration: options?.fadeOutDuration ?? 0 });
}
